import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useUserPermissionOrFeatureFlagEnabled } from '../../../../../../taboola-common-frontend-modules/./account-configurations/hooks/useUserPermissionOrFeatureFlagEnabled';

export const useReachEstimatorEnabled = () => {
    return useUserPermissionOrFeatureFlagEnabled(
        'ADS_CONSOLE_REACH_ESTIMATOR',
        FEATURE_FLAGS.ADS_CONSOLE_REACH_ESTIMATOR_ALLOWED
    );
};
